import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { Checkup } from './checkup.model';

export const loadCheckups = createAction(
    '[Checkup/API] Load Checkups',
    props<{ checkups: Checkup[] }>()
);

export const addCheckup = createAction(
    '[Checkup/API] Add Checkup',
    props<{ checkup: Checkup }>()
);

export const upsertCheckup = createAction(
    '[Checkup/API] Upsert Checkup',
    props<{ checkup: Checkup }>()
);

export const addCheckups = createAction(
    '[Checkup/API] Add Checkups',
    props<{ checkups: Checkup[] }>()
);

export const upsertCheckups = createAction(
    '[Checkup/API] Upsert Checkups',
    props<{ checkups: Checkup[] }>()
);

export const updateCheckup = createAction(
    '[Checkup/API] Update Checkup',
    props<{ checkup: Update<Checkup> }>()
);

export const updateCheckups = createAction(
    '[Checkup/API] Update Checkups',
    props<{ checkups: Update<Checkup>[] }>()
);

export const deleteCheckup = createAction(
    '[Checkup/API] Delete Checkup',
    props<{ id: string }>()
);

export const deleteCheckups = createAction(
    '[Checkup/API] Delete Checkups',
    props<{ ids: string[] }>()
);

export const clearCheckups = createAction('[Checkup/API] Clear Checkups');
export const getCheckups = createAction(
    '[Checkup/API] Get Checkups',
    props<{ ProcessID?: number, EmployeeListID?: string }>()
);
